import { Box } from "@mui/material";

const ManagementTabPanel = ({ active, id, children }) => {
  if (!active) return null;

  return (
    <Box
      role="tabpanel"
      id={`management-tabpanel-${id}`}
      aria-labelledby={`management-tab-${id}`}
      sx={{ pt: 2 }}
    >
      {children}
    </Box>
  );
};

export default ManagementTabPanel;
